export const services = [
  {
    icon: 'ri-video-line',
    title: '短视频制作',
    description: '从创意策划到精良后期，我们打造具有病毒传播潜力的品牌短视频内容。涵盖抖音、快手、视频号等全平台格式。',
    features: ['创意脚本策划', '专业拍摄团队', '精良后期制作', '平台适配优化'],
  },
  {
    icon: 'ri-share-line',
    title: '社交媒体运营',
    description: '微信、微博、小红书、抖音等多平台矩阵运营，通过数据驱动的内容策略实现品牌声量与用户增长双提升。',
    features: ['多平台矩阵搭建', '内容日历规划', '用户互动管理', '数据复盘优化'],
  },
  {
    icon: 'ri-lightbulb-line',
    title: '广告策划',
    description: '基于深度消费者洞察，打造有记忆点、有传播力的品牌广告，从TVC到信息流，覆盖全媒体形式。',
    features: ['消费者洞察研究', '创意策略规划', '视觉语言设计', '媒介投放优化'],
  },
  {
    icon: 'ri-stack-line',
    title: '全案营销',
    description: '从品牌战略到执行落地，提供一站式整合营销服务，确保品牌传播的一致性与协同效应最大化。',
    features: ['品牌战略咨询', '整合传播规划', '全渠道执行', '效果追踪优化'],
  },
  {
    icon: 'ri-quill-pen-line',
    title: '内容创意',
    description: '原创内容生产与创意策划，用有温度的好内容连接品牌与消费者，让每一次传播都产生情感共鸣。',
    features: ['品牌故事创作', '创意内容策划', '视觉创意设计', 'IP内容开发'],
  },
];

export const stats = [
  { value: '500+', label: '服务品牌' },
  { value: '10万+', label: '产出内容' },
  { value: '50亿+', label: '累计曝光' },
  { value: '98%', label: '客户满意度' },
];

export const partners = [
  { name: '华为', industry: '科技' },
  { name: '小米', industry: '科技' },
  { name: '阿里巴巴', industry: '互联网' },
  { name: '字节跳动', industry: '互联网' },
  { name: '欧莱雅', industry: '美妆' },
  { name: '耐克', industry: '运动' },
  { name: '星巴克', industry: '餐饮' },
  { name: '万科', industry: '地产' },
  { name: '招商银行', industry: '金融' },
  { name: '蔚来汽车', industry: '出行' },
];

export const cases = [
  {
    id: 1,
    title: '某美妆品牌抖音全案营销',
    category: '全案营销',
    description: '通过系统化的内容策略与KOL矩阵，帮助品牌在6个月内实现粉丝从0到100万的增长，线上销售额提升300%。',
    image: 'https://readdy.ai/api/search-image?query=Beauty%20brand%20marketing%20campaign%20display%20with%20product%20photography%20and%20social%20media%20content%20on%20screen%2C%20modern%20creative%20office%20setting%2C%20warm%20soft%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20professional%20commercial%20photography%20style%20with%20soft%20warm%20tones&width=600&height=400&seq=case-study-01&orientation=landscape',
    tags: ['短视频', 'KOL合作', '电商转化'],
    result: '销售额增长300%',
  },
  {
    id: 2,
    title: '某科技品牌年度品牌TVC',
    category: '广告策划',
    description: '打造品牌年度TVC广告片，全网播放量突破8000万，品牌搜索指数同比提升150%。',
    image: 'https://readdy.ai/api/search-image?query=Technology%20brand%20commercial%20film%20production%20scene%20with%20professional%20camera%20crew%20and%20futuristic%20product%20setup%2C%20warm%20cinematic%20lighting%2C%20behind%20the%20scenes%20photography%2C%20soft%20golden%20tones%2C%20editorial%20commercial%20photography%20style&width=600&height=400&seq=case-study-02&orientation=landscape',
    tags: ['TVC广告', '品牌升级', '全网传播'],
    result: '播放量8000万+',
  },
  {
    id: 3,
    title: '某餐饮品牌社交媒体矩阵搭建',
    category: '社交媒体运营',
    description: '从零搭建品牌社交媒体矩阵，覆盖微信、微博、小红书、抖音四大平台，月均互动量超50万次。',
    image: 'https://readdy.ai/api/search-image?query=Restaurant%20food%20photography%20social%20media%20content%20creation%20setup%20with%20delicious%20dishes%20and%20smartphone%2C%20warm%20ambient%20lighting%2C%20cozy%20modern%20cafe%20atmosphere%2C%20soft%20warm%20tones%2C%20editorial%20food%20photography%20style%20with%20natural%20textures&width=600&height=400&seq=case-study-03&orientation=landscape',
    tags: ['社交媒体', '内容矩阵', '用户互动'],
    result: '月互动量50万+',
  },
];

export const faqItems = [
  {
    question: '果冻传媒的服务流程是怎样的？',
    answer: '我们的标准服务流程分为四个阶段：需求沟通与品牌诊断 → 策略方案制定 → 创意执行与内容生产 → 效果追踪与优化迭代。每个阶段都会有专属客户经理与您保持密切沟通，确保项目顺利推进。',
  },
  {
    question: '果冻传媒的核心优势是什么？',
    answer: '我们拥有三大核心优势：一是顶尖的创意团队，核心成员来自4A广告公司和头部互联网平台；二是数据驱动的策略能力，所有创意都基于消费者洞察和数据分析；三是全链路的执行能力，从策略到制作到投放，一站式服务让品牌传播更高效。',
  },
  {
    question: '合作一般需要多长周期？',
    answer: '合作周期因项目类型而异。短视频制作项目通常为2-4周，品牌TVC广告项目通常为4-8周，全案营销通常以季度或年度为合作周期。我们会根据您的具体需求，制定合理的时间规划。',
  },
  {
    question: '果冻传媒服务过哪些行业的客户？',
    answer: '我们服务过的客户覆盖美妆、科技、餐饮、金融、地产、出行等多个行业。不同行业的经验积累让我们具备跨领域的创意能力和策略视野。',
  },
  {
    question: '如何获取报价和合作方案？',
    answer: '您可以通过官网的联系表单提交需求，我们的商务团队会在24小时内与您联系，了解您的具体需求后提供定制化的报价和合作方案。',
  },
];

export const teamMembers = [
  {
    name: '张明远',
    title: '创始人 & 创意总监',
    description: '前奥美创意组长，15年广告创意经验，曾获戛纳创意节铜狮奖。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20creative%20director%20portrait%2C%20warm%20studio%20lighting%2C%20confident%20expression%2C%20modern%20business%20casual%20attire%2C%20clean%20neutral%20background%2C%20soft%20warm%20tones%2C%20editorial%20portrait%20photography%20style&width=300&height=300&seq=team-01&orientation=squarish',
  },
  {
    name: '李思涵',
    title: '联合创始人 & 运营总监',
    description: '前字节跳动运营负责人，擅长数据驱动的社交媒&#x4F53;运营策略。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20operations%20director%20portrait%2C%20warm%20studio%20lighting%2C%20friendly%20professional%20expression%2C%20modern%20business%20attire%2C%20clean%20neutral%20background%2C%20soft%20warm%20tones%2C%20editorial%20portrait%20photography%20style&width=300&height=300&seq=team-02&orientation=squarish',
  },
  {
    name: '王浩然',
    title: '策略总监',
    description: '前麦肯锡品牌策略顾问，擅长品牌定位与整合营销策略规划。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20strategy%20director%20portrait%2C%20warm%20studio%20lighting%2C%20thoughtful%20expression%2C%20modern%20business%20casual%20attire%2C%20clean%20neutral%20background%2C%20soft%20warm%20tones%2C%20editorial%20portrait%20photography%20style&width=300&height=300&seq=team-03&orientation=squarish',
  },
  {
    name: '赵雨晴',
    title: '客户总监',
    description: '10年品牌客户服务经验，服务过多个世界500强品牌客户。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20account%20director%20portrait%2C%20warm%20studio%20lighting%2C%20bright%20professional%20smile%2C%20modern%20business%20attire%2C%20clean%20neutral%20background%2C%20soft%20warm%20tones%2C%20editorial%20portrait%20photography%20style&width=300&height=300&seq=team-04&orientation=squarish',
  },
];

export const milestones = [
  { year: '2015', event: '果冻传媒在北京成立，初始团队5人' },
  { year: '2016', event: '完成首个百万级品牌全案项目' },
  { year: '2018', event: '团队扩展至50人，服务品牌超过100家' },
  { year: '2020', event: '成立短视频事业部，布局新媒体内容赛道' },
  { year: '2022', event: '累计产出内容突破10万条，年营收突破5000万' },
  { year: '2024', event: '荣获中国广告长城奖年度最佳创意机构' },
  { year: '2026', event: '服务品牌突破500家，团队规模超200人' },
];

export const reputation = [
  {
    quote: '果冻传媒的创意团队拥有极强的品牌理解力和执行效率，让我们的品牌焕发了全新的生命力。',
    author: '陈总',
    company: '某知名美妆品牌 市场VP',
  },
  {
    quote: '合作三年来，果冻传媒始终能给我们带来惊喜。他们对消费者洞察的深度和对内容品质的追求令人印象深刻。',
    author: '刘总',
    company: '某头部科技公司 品牌总监',
  },
  {
    quote: '从品牌策略到创意执行，果冻传媒展现了极高的专业度。是我们最信赖的营销合作伙伴。',
    author: '孙总',
    company: '某新锐消费品牌 创始人',
  },
  {
    quote: '果冻传媒的团队像我们自己的市场部一样用心。他们不只是执行者，更是值得信赖的品牌伙伴。',
    author: '周总',
    company: '某连锁餐饮品牌 CMO',
  },
];